export const visit = "Visit"
export const cleaning = "Cleaning"
export const logout = "Logout"
export const DateRange = "Date Range"
export const ChangeDates = "Change Dates"
export const Cancel = "Cancel"
export const Apply = "Apply"
export const AllStores = "All Stores"
export const SelectedStores = "Selected Stores"
export const Config = "Admin Config"
export const Help = "Help"
export const CleanersDashboard = "Dashboard"